<template>
  <div
    class="status"
    :style="`background-image: url(${icon})`"
  >
    {{ label }}
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .status {
    width: 100%;
    border: 1.5px solid $nh-gray;
    border-radius: 5px;
    padding: 0.5rem;
    padding-left: 2rem;
    background-position: left 0.5rem center;
    background-repeat: no-repeat;
    text-align: center;
    font-size: 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    background-size: auto 0.8rem;
  }
</style>
